<template>
  <div class="ui-toggle">
    <label
      class="ui-toggle__label"
      :class="{checked: modelValue}"
    >
      <input
        type="checkbox"
        :checked="modelValue"
        hidden
        class="ui-toggle__input"
        @input="emit('update:modelValue', $event.target.checked)"
      >
    </label>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modelValue?: boolean,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
}>();
</script>

<style scoped lang="scss">
.ui-toggle {
  width: 40px;
  height: 20px;
  position: relative;

  &__input {
    display: none;
  }

  &__label {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 13px;
    background: #f5f5f5;
    position: relative;

    &::before {
      content: '';
      width: 18px;
      height: 18px;
      position: absolute;
      top: 1px;
      left: 2px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
      transition: .3s;
    }

    &.checked {
      background: #202020;

      &::before {
        left: calc(100% - 20px);
      }
    }
  }
}
</style>
